var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCantFindSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 169.077,
    height: 84.259,
    viewBox: "0 0 169.077 84.259",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Error_illustration",
    "data-name": "Error illustration",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 8.311,
    cy: 8.311,
    r: 8.311,
    transform: "translate(37.853 52.293)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M351.478,519.474a8.312,8.312,0,0,0,13.849,8.8,8.312,8.312,0,1,1-13.849-8.8Z",
    transform: "translate(-311.451 -464.422)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M246.411,325.819h.023l.411,23.563h-.868Z",
    transform: "translate(-200.225 -265.215)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 16.757,
    cy: 16.757,
    r: 16.757,
    transform: "translate(12.591 19.903)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M218.181,360.416A16.758,16.758,0,0,0,246.1,378.151a16.758,16.758,0,1,1-27.921-17.735Z",
    transform: "translate(-201.206 -334.949)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M154.2,197.087h.046l.829,47.508h-1.749Z",
    transform: "translate(-124.808 -160.428)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 76.805,
    height: 22.768,
    transform: "translate(63.02 59.577)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 8.955,
    height: 18.063,
    transform: "translate(96.944 64.282)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 67.849,
    height: 20.947,
    transform: "translate(67.497 32.711)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M550.018,257.5H468.412a.683.683,0,0,1-.473-1.175l22.3-21.438V225.55a.684.684,0,0,1,.683-.683h4.4a.684.684,0,0,1,.683.683v3.794l1.685-1.619a15.136,15.136,0,0,1,20.609-.343l32.172,28.928a.683.683,0,0,1-.457,1.191Z",
    transform: "translate(-407.793 -223.5)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M440.245,204.421h0a4.326,4.326,0,0,1,4.326,4.326v5.844h-8.652v-5.844A4.326,4.326,0,0,1,440.245,204.421Z",
    transform: "translate(-354.837 -166.398)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M526.338,204.829h0a4.326,4.326,0,0,1,4.326,4.326V215h-8.652v-5.844A4.326,4.326,0,0,1,526.338,204.829Z",
    transform: "translate(-424.916 -166.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M612.432,205.237h0a4.326,4.326,0,0,1,4.326,4.326v5.844h-8.652v-5.844A4.326,4.326,0,0,1,612.432,205.237Z",
    transform: "translate(-494.996 -167.062)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M646.706,344.373h0a4.326,4.326,0,0,1,4.326,4.326v5.844H642.38V348.7A4.326,4.326,0,0,1,646.706,344.373Z",
    transform: "translate(-522.895 -280.318)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M416.58,344.373h0a4.326,4.326,0,0,1,4.326,4.326v5.844h-8.652V348.7A4.326,4.326,0,0,1,416.58,344.373Z",
    transform: "translate(-335.573 -280.318)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M521.647,517.585l-14.408-6.375a.607.607,0,0,0-.246-.052H438.329a.607.607,0,0,0-.229.045l-15.683,6.375a.607.607,0,0,0,.229,1.17h4.069v20.947h-.455v2.125h91.528v-2.125h-.759V518.747H521.4a.607.607,0,0,0,.246-1.162Zm-5.832,22.109H427.929V518.747h87.885Z",
    transform: "translate(-370.602 -457.652)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 11.081,
    height: 1.821,
    transform: "translate(79.716 47.358)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 11.081,
    height: 1.821,
    transform: "translate(95.957 47.358)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 11.081,
    height: 1.821,
    transform: "translate(112.199 47.358)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 11.081,
    height: 1.821,
    transform: "translate(118.27 73.617)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 11.081,
    height: 1.821,
    transform: "translate(75.314 73.617)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M314.391,674.872h-168.7a.186.186,0,1,1,0-.372h168.7a.186.186,0,1,1,0,.372Z",
    transform: "translate(-145.5 -590.612)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M649.461,385.462c0,.119,0,.24,0,.359,0,.143-.006.285-.011.428-.005.125-.011.247-.019.37-.022.411-.058.82-.106,1.231-.011.1-.024.206-.039.311-.011.08-.022.162-.035.244s-.026.182-.041.273q-.045.29-.1.58c-.019.1-.037.193-.058.29-.039.192-.082.385-.126.577l-.011.047c-.022.095-.045.188-.069.283-.007.028-.013.054-.022.082-.017.071-.035.141-.054.212-.026.1-.052.2-.08.294-.045.153-.089.3-.136.456-.006.016-.011.032-.015.048-.089.288-.184.573-.288.856-.054.149-.112.3-.169.448s-.117.3-.179.445-.121.286-.182.428c-.015.033-.03.067-.047.1-.065.147-.132.29-.2.433,0,0,0,.006,0,.007-.054.115-.112.231-.169.344a.014.014,0,0,1,0,.009c-.056.112-.113.223-.173.333l-.095.18-.011.02c-.119.221-.242.441-.372.658-.028.048-.056.1-.084.143s-.058.1-.087.143-.039.067-.061.1c-.039.063-.078.128-.119.192-.007.013-.017.026-.024.039l-.212.327c-.087.132-.177.262-.268.392l-2.02,3.233-.087-.073-.024-.022h0l-.08-.067-.219-.186c-.067.065-.132.13-.2.193-.026.026-.054.05-.08.076l-.06.056A19.478,19.478,0,0,1,630,405.89h-.006a21.26,21.26,0,0,1-10.608-2.5c-.073-.037-.143-.074-.214-.117-.424-.231-.839-.474-1.246-.735l-.006,0q-.709-.5-1.384-1.071a20.447,20.447,0,0,1-7.241-16.7c.006-.125.013-.247.022-.372q.045-.675.138-1.345c.017-.125.035-.249.054-.372h39.764q.117.854.162,1.717C649.452,384.746,649.461,385.1,649.461,385.462Z",
    transform: "translate(-523.004 -353.063)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M649.491,307.769a20.105,20.105,0,0,0-39.764,0c-.019.123-.037.247-.054.372q-.092.67-.138,1.345h40.117Q649.609,308.623,649.491,307.769Z",
    transform: "translate(-523.224 -278.162)",
    fill: "#c2b59c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M674.042,434.555H662.521v-9.216c.213-4.212,3.812-4.552,7.195-4.326a4.326,4.326,0,0,1,4.326,4.326Z",
    transform: "translate(-566.354 -384.232)",
    fill: "#c2b59c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M619.171,321.024v0s0,0,0,0Zm-4.633-14.164c-.007.047-.017.093-.024.14.007-.047.017-.093.026-.14Zm-.231,1.717c-.006.071-.011.141-.015.212q.006-.106.017-.212a.261.261,0,0,1,0-.039C614.308,308.55,614.308,308.563,614.307,308.576Zm4.864,12.449s0,0,0,0l0,0Zm-4.633-14.166c-.007.047-.017.093-.024.14.007-.047.017-.093.026-.14Zm-.246,1.929q.006-.106.017-.212a.261.261,0,0,1,0-.039c0,.013,0,.026,0,.039C614.3,308.647,614.3,308.718,614.292,308.788Zm57.464,34.217a1.248,1.248,0,0,0-.115-.108l0,0-9.211-7.773-.238-.2-.906-.764-.227-.192-1.291-1.09-.353-.3-.731-.617-.374-.316-3.527-2.974-2.022-1.706-.272-.229-5.958-5.028c.091-.13.18-.26.268-.392l.212-.327c.007-.013.017-.026.024-.039.041-.063.08-.128.119-.192q.034-.05.061-.1c.03-.047.06-.095.087-.143s.056-.095.084-.143c.13-.218.253-.437.372-.658l.011-.02.095-.18c.06-.11.117-.221.173-.333a.014.014,0,0,0,0-.009c.058-.113.115-.229.169-.344,0,0,0-.006,0-.007.069-.143.136-.286.2-.433.017-.033.032-.067.047-.1.061-.141.123-.285.182-.428s.121-.3.179-.445.115-.3.169-.448q.153-.427.288-.856a.476.476,0,0,1,.015-.048c.047-.153.091-.3.136-.456.028-.1.054-.2.08-.294.019-.071.037-.141.054-.212.009-.028.015-.054.022-.082.024-.095.047-.188.069-.283l.011-.047c.045-.192.087-.385.126-.577.021-.1.039-.193.058-.29.035-.193.071-.387.1-.58.015-.091.028-.182.041-.273s.024-.164.035-.244c.015-.1.028-.206.039-.311.048-.411.084-.82.106-1.231.007-.123.013-.246.019-.37.006-.143.009-.285.011-.428,0-.119,0-.24,0-.359,0-.359-.009-.716-.028-1.075q-.045-.862-.162-1.717a20.47,20.47,0,0,0-40.508-.372c-.019.123-.037.247-.054.372q-.092.67-.138,1.345c-.009.125-.017.247-.022.372a20.447,20.447,0,0,0,7.241,16.7q.675.569,1.384,1.071l.006,0c.158.112.316.221.476.329.255.167.511.331.77.487l.061.035c.223.134.448.262.673.387h0a20.118,20.118,0,0,0,2.6,1.2,20.532,20.532,0,0,0,8.227,1.291h.006a20.416,20.416,0,0,0,9.283-2.747c.411-.238.817-.493,1.213-.764.1-.067.2-.136.3-.2.119-.084.238-.171.357-.259l0,0,.028-.02.24-.182c.021-.015.041-.03.061-.047l.015-.013c.047-.033.091-.071.138-.106s.091-.073.138-.11l.022-.017.156-.126c.054-.043.106-.087.156-.13s.1-.086.154-.13.091-.076.136-.117c.015-.011.028-.024.043-.037l.019-.015c.061-.052.121-.106.18-.16l.043-.039c.091-.082.182-.164.272-.249l.063-.058.06-.056c.026-.026.054-.05.08-.076.067-.063.132-.128.2-.193l.219.186.08.067h0l.024.022.087.073,1.3,1.1.028.024.022.017.147.125.294.249.294.247.043.035L648,327.889l.19.16,1.319,1.112,6.826,5.761.238.2,9.343,7.883,2.4,2.022.891.751a1.885,1.885,0,0,0,2.658-.223,1.83,1.83,0,0,0,.314-.528A1.877,1.877,0,0,0,671.755,343.005Zm-53.88-43.117a15.335,15.335,0,0,1,26.775,6.971c.024.125.047.247.067.372.076.445.132.895.166,1.345.009.125.019.247.024.372.017.279.024.56.024.839a15.268,15.268,0,0,1-.83,4.974v0a15.254,15.254,0,0,1-2.784,4.907c-.026.03-.052.061-.08.091-.245.29-.5.569-.77.835l-.006.007c-.091.091-.184.184-.277.27q-.285.276-.58.526-.444.388-.91.727c-.1.076-.208.151-.314.225s-.21.145-.316.216c-.212.141-.428.277-.645.405-.108.065-.219.128-.329.19s-.221.123-.333.18-.223.117-.337.173c-.225.113-.452.219-.683.318q-.173.078-.346.145c-.073.03-.143.06-.216.086a.7.7,0,0,1-.087.033q-.059.025-.117.045l-.039.015c-.08.032-.158.06-.24.087-.117.043-.234.082-.353.119s-.236.076-.355.11-.24.071-.359.1-.24.065-.361.093-.257.063-.387.091c-.113.026-.225.048-.339.069s-.214.041-.32.06c-.149.026-.3.05-.448.071-.082.013-.162.024-.244.032-.035.006-.069.009-.1.013-.1.015-.208.026-.311.035l-.08.007c-.113.011-.229.02-.342.03-.244.017-.485.028-.729.033-.123,0-.247,0-.37,0s-.246,0-.368-.006c0,0,0,0,0,0s0,0,0,0h0a.032.032,0,0,1-.019,0c-.087,0-.175,0-.26-.009-.063,0-.128,0-.193-.009q-.131-.006-.262-.017c-.028,0-.056,0-.084-.006l-.039,0c-.089-.007-.18-.015-.27-.024-.045,0-.091-.007-.136-.013-.136-.015-.272-.032-.405-.05-.153-.019-.305-.041-.456-.069-.071-.009-.139-.022-.208-.035q-.137-.022-.273-.05c-.095-.019-.19-.037-.285-.06-.076-.017-.154-.033-.231-.052-.037-.007-.074-.017-.11-.026-.2-.046-.389-.1-.58-.153-.121-.033-.242-.069-.361-.106-.164-.05-.325-.1-.487-.162-.063-.02-.125-.043-.188-.067s-.125-.045-.188-.069-.115-.043-.171-.065c-.093-.035-.184-.073-.275-.11-.188-.076-.372-.156-.556-.242-.1-.05-.208-.1-.311-.149q-.605-.293-1.192-.651c-.1-.058-.193-.119-.29-.18-.121-.074-.238-.153-.355-.231-.065-.045-.128-.087-.192-.132-.117-.082-.232-.166-.346-.249-.06-.043-.119-.087-.177-.132-.206-.156-.409-.32-.608-.487-.095-.08-.19-.162-.283-.246-.039-.033-.078-.069-.117-.1s-.089-.08-.132-.123l0,0c-.065-.058-.13-.119-.193-.18-.1-.093-.2-.188-.288-.285s-.19-.193-.281-.29-.182-.2-.27-.3-.177-.2-.262-.3-.166-.2-.244-.3q-.285-.352-.543-.716c-.08-.112-.156-.223-.231-.337s-.156-.233-.229-.35-.149-.236-.219-.357a.04.04,0,0,0-.007-.011c-.14-.236-.273-.474-.4-.716s-.249-.493-.363-.744c-.058-.125-.113-.251-.166-.378-.108-.255-.208-.51-.3-.768-.047-.125-.089-.249-.132-.376a.091.091,0,0,0-.007-.024c-.086-.257-.164-.515-.232-.776,0,0,0-.007,0-.011-.035-.128-.069-.257-.1-.387-.03-.113-.056-.227-.08-.342s-.056-.257-.08-.387c-.013-.067-.026-.134-.037-.2s-.021-.113-.03-.169l-.028-.171q-.028-.17-.05-.34c-.019-.134-.034-.268-.048-.4-.017-.162-.032-.324-.045-.487-.009-.11-.015-.221-.02-.333s-.011-.2-.013-.307a.026.026,0,0,1,0-.017v0s0,0,0,0v0c0-.041,0-.082,0-.123q-.006-.181-.006-.363c0-.11,0-.218,0-.327q.006-.229.017-.458c0-.034,0-.065.006-.1l.006-.1q.006-.106.017-.212a.279.279,0,0,1,0-.039c.006-.08.013-.16.02-.24.015-.16.034-.322.054-.482.011-.08.02-.16.034-.24.007-.056.017-.113.026-.171s.017-.115.028-.173c.013-.076.026-.154.041-.233.007-.046.017-.093.026-.139q.053-.279.117-.558c.043-.188.091-.374.143-.56s.106-.376.166-.564c.028-.095.058-.188.091-.281.061-.188.126-.374.2-.558.034-.091.069-.184.108-.275.074-.184.153-.368.233-.549.041-.091.082-.182.126-.273.084-.18.171-.361.266-.538s.19-.357.29-.532.2-.35.314-.523c.05-.086.106-.173.164-.257.112-.171.229-.342.348-.51C617.344,300.545,617.6,300.212,617.876,299.888Zm-3.569,8.688c-.006.071-.011.141-.015.212q.006-.106.017-.212a.261.261,0,0,1,0-.039C614.308,308.55,614.308,308.563,614.307,308.576Zm.231-1.717c-.007.047-.017.093-.024.14.007-.047.017-.093.026-.14Zm4.633,14.164v0s0,0,0,0Z",
    transform: "translate(-523.004 -277.253)",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 6.866,
    y2: 5.15,
    transform: "translate(100.239 22.638) rotate(8)",
    fill: "none",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 6.866,
    y2: 5.15,
    transform: "translate(106.308 22.624) rotate(98)",
    fill: "none",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M634.466,371.156a15.337,15.337,0,0,1-2.6-20.617q-.44.443-.85.928a15.336,15.336,0,1,0,23.442,19.78q.41-.485.771-.994A15.337,15.337,0,0,1,634.466,371.156Z",
    transform: "translate(-537.763 -326.909)",
    opacity: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCantFindSvg);
export default __webpack_public_path__ + "static/media/cantFindSVG.476caded5852589402e1b53543ce7cbb.svg";
export { ForwardRef as ReactComponent };